import React from "react";
import { qrImageUrl, qrMenuBrowseUrl } from "@/lib/qrMenuThemes";
import "@/styles/qr-menu-themes.css";

/**
 * Printable QR tent cards (view-only browse URL).
 * `count` = how many identical cards to print (default 1).
 */
export function QrMenuCardPrint({
  restaurantName,
  tagline,
  theme = "warm_spice",
  logoUrl,
  branchCode,
  count = 1,
  className = "",
}) {
  const browseUrl = qrMenuBrowseUrl(branchCode);
  const cards = Array.from({ length: Math.max(1, Number(count) || 1) }, (_, i) => i);

  return (
    <div className={`qr-card-print-root ${className}`.trim()} aria-hidden="true">
      <div className="qr-card-sheet">
        {cards.map((i) => (
          <article key={i} className="qr-tent-card" data-theme={theme}>
            <div className="qr-tent-hero">
              {logoUrl ? (
                <img src={logoUrl} alt="" className="qr-tent-logo" />
              ) : null}
              <h3>{restaurantName}</h3>
              {tagline ? <p>{tagline}</p> : <p>Scan to view today’s menu & prices</p>}
            </div>
            <div className="qr-tent-body">
              <img src={qrImageUrl(browseUrl, 240)} alt={`QR for ${restaurantName}`} />
              <div className="qr-tent-url">{browseUrl.replace(/^https?:\/\//, "")}</div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

/** On-screen preview of a single tent card (visible, not print-only). */
export function QrMenuCardPreview({
  restaurantName,
  tagline,
  theme = "warm_spice",
  logoUrl,
  branchCode,
}) {
  const browseUrl = qrMenuBrowseUrl(branchCode);

  return (
    <article className="qr-tent-card qr-tent-preview" data-theme={theme}>
      <div className="qr-tent-hero">
        {logoUrl ? <img src={logoUrl} alt="" className="qr-tent-logo" /> : null}
        <h3>{restaurantName}</h3>
        {tagline ? <p>{tagline}</p> : <p>Scan to view today’s menu & prices</p>}
      </div>
      <div className="qr-tent-body">
        <img src={qrImageUrl(browseUrl, 200)} alt="" />
        <div className="qr-tent-url">{browseUrl.replace(/^https?:\/\//, "")}</div>
      </div>
    </article>
  );
}

export function printQrMenuCards() {
  window.print();
}
